import React from 'react';
import './Verification.css';
import { withRouter } from "react-router";
import { OverlayTrigger, Popover } from "react-bootstrap";
import Helmet from "react-helmet/es/Helmet";
import Button from "react-bootstrap/Button";
import FaqButtonService from "../faq-button-service/faq-button-service";
import Popup from 'reactjs-popup';

class Verification extends React.Component {

    constructor(props) {
        super(props);
        this.siteConfigData = this.props.siteConfigData;
        this.state = {
            confirmationNumber: '',
            emailAddress: '',
            guestLastName: '',
            showVerificationErrorMessage: false,
            verificationErrorMessage: '',
            accessReservationBookingDisabled: false,
            errorClassBookingNumber: '',
            errorClassEmail: '',
            errorClassLastName: '',
            errors: new Map(),
            emailAddressAlt: '',
            emailAddressValue: '',
            guestLastNameAlt: '',
            guestLastNameValue: '',
            confirmationNumberAlt: '',
            confirmationNumberValue: '',
            partnerCode: `${this.siteConfigData.partnercode} - `,
            isResendBooking: false,
            isBookingConfirmation: false,


        }

        this.popover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">
                    <span>Order Number</span>
                    <Button variant="" className="rea-floatRight rea-popOverClose"
                        onClick={this.hidePopover}>
                        <i className="fa fa-times-circle" aria-hidden="true"></i>
                    </Button>
                </Popover.Title>
                <Popover.Content>
                    This is the <strong> order number </strong> found on your invoice.
                    <div className="rea-orderNumberImg">
                        <img
                            src="/images_unique/css/order-num.png" alt="" />
                    </div>
                </Popover.Content>
            </Popover>
        );


        /* window.dataLayer = window.dataLayer || [];
         try {
             window.dataLayer.push({
                 'event': 'VirtualPageview',
                 'virtualPageURL': 'gaVirtualPageURL',
                 'virtualPagePath': '/css/login.do',
                 'virtualPageTitle': 'Customer Self Service - Login'
             });
         } catch (error) {
             //swallow error
         }*/

        this.htmlElementFocused = false;

    }
    
    componentDidMount() {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N')  {

            if (this.props.sessionExpired) {
                document.querySelector('.wth3-login-container').style.minHeight = '51.3125rem';
                document.querySelector('.wth3-login__sub-header').style.marginBottom = '2rem';
            }

            let regexBN = /(^[0-9]{8}$)/;
            const queryParameters = new URLSearchParams(window.location.search);
            const typeBookingNumber = queryParameters.get("bookingNumber");    	
            if(regexBN.test(typeBookingNumber)){  
                const elTarget = document.getElementById("bookingNumber").parentNode;
                elTarget.classList.add('active');
                
                document.getElementById("bookingNumber").value = this.state.partnerCode + typeBookingNumber;
                
                this.setState({
                    confirmationNumberValue: this.state.partnerCode + typeBookingNumber
                })
                this.setState({
                    confirmationNumberAlt: typeBookingNumber
                })
            }   	
            else{
                // console.log("Invalid Booking Number Parameter");
            }
            if (this.getSitePropertyValue('RESEND_BOOKING_CONFIRMATION_EMAIL') === 'Y') {
                const resendLinkRef = document.getElementById('resendConfirmationEmail');
                resendLinkRef.addEventListener('keyup', function(event) {
                    if (event.which === 13) {
                        resendLinkRef.click();
                    }
                })
            }
        }  else {
            let regexBN = /(^[0-9]{8}$)/;
            const queryParameters = new URLSearchParams(window.location.search);
            const typeBookingNumber = queryParameters.get("bookingNumber");    	
            if(regexBN.test(typeBookingNumber)){  
                document.getElementById("bookingNumber").value = typeBookingNumber;
                
                this.setState({ confirmationNumber: typeBookingNumber });
            }   	
            else{
                // console.log("Invalid Booking Number Parameter");
            }
            if (this.getSitePropertyValue('RESEND_BOOKING_CONFIRMATION_EMAIL') === 'Y') {
                const resendLinkRef = document.getElementById('resendConfirmationEmail');
                resendLinkRef.addEventListener('keyup', function(event) {
                    if (event.which === 13) {
                        resendLinkRef.click();
                    }
                })
            }
        }

    }
    
    

    executeScroll = () => {
        window.scrollTo({
            top: 150,           
            behavior: 'smooth'
          });
    }
    
    getCookie = (cname) => {
    	let name = cname + "=";
  		let decodedCookie = decodeURIComponent(document.cookie);
  		let ca = decodedCookie.split(';');
  		for(let i = 0; i <ca.length; i++) {
  			let c = ca[i];
  			while (c.charAt(0) === ' ') {
  				c = c.substring(1);
  			}
  			if (c.indexOf(name) === 0) {
  				return c.substring(name.length, c.length);
  			}
  		}
  		return "";
  	}

    getStoreAttValue = (attCode) => {
        let storeAttributeValue = '';
        for (let i = 0; i < this.props.siteConfigData.store.storeAttributes.length; i++) {
            if (this.props.siteConfigData.store.storeAttributes[i].attributeCode === attCode) {
                storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
            }
        }
        return storeAttributeValue;
    }

    getTemplatePropertyValue = (propertyName) => {
        let templatePropertyValue = '';
        for (let j = 0; j < this.props.siteConfigData.templateProperties.length; j++) {
            if (this.props.siteConfigData.templateProperties[j].propertyName === propertyName) {
                templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
            }
        }
        return templatePropertyValue;
    }
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }

    getExploreDiscountedAddonLink = () => {
		let baseUrl = this.props.siteConfigData.domainName.replace(/^www\./, '');
    	let rewardsLink = "https://rewards." + baseUrl;
    	return rewardsLink;
    }
    
    displayForm = () => {
        const close = document.getElementById('resendFormCloseText');
        close.addEventListener('keyup', function (event) {
            if (event.which === 13) {
                close.click();
            }
        });
        this.resetValidationErrors();
        this.clearResendFormFields();
        this.props.CallTracker("BCSS Login","Resend Booking Confirmation Email","Open");
        let element = document.getElementById("css_resendFormContent");
        let status = window.getComputedStyle(element, null).getPropertyValue("display");
        if (status === "none") {
            element.style.display = "block";
            this.focusOnCloseButton();
        } else {
            element.style.display = "none";
        }
    }

    resetInputVals = () => {
        this.setState({emailAddressValue: ''})
        this.setState({guestLastNameValue: ''})
        this.setState({confirmationNumberValue: ''})
        this.setState({emailAddressAlt: ''})
        this.setState({guestLastNameAlt: ''})
        this.setState({confirmationNumberAlt: ''})
        this.setState({ errors: new Map() })
        this.setState({ errorClassBookingNumber: '' });
        this.setState({ errorClassEmail: '' });
        this.setState({ errorClassLastName: '' });
        this.setState({showVerificationErrorMessage: false})
        this.setState({verificationErrorMessage: ''})

        this.props.sessionExpired = false;
        this.props.sessionExpiredMessage = null;
        document.querySelector('.wth3-login-container').style.minHeight = '45.3125rem';
        document.querySelector('.wth3-login__sub-header').style.marginBottom = '3rem';
    }

    toggleForms = () => {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            if (this.state.isResendBooking) {
                this.setState({isResendBooking: false});
            } else {
                this.setState({isResendBooking: true});
            }
            this.resetInputVals();
        }
    }

    toggleResendAndCheckEmailForm = () => {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            if (this.state.isBookingConfirmation) {
                this.setState({isBookingConfirmation: false});
                this.setState({isResendBooking: true});
            } else {
                this.setState({isBookingConfirmation: true});
            }

            this.resetInputVals();
        }
    }

    toggleFormBackToManageMyCruise = () => {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
                this.setState({isBookingConfirmation: false});
                this.setState({isResendBooking: false});
        }
    }


    
    clearResendFormFields = () => {
        document.getElementById("resendLastName").value = ''
        document.getElementById("resendEmail").value = ''
    }


    /* Spinner for Ajax calls */
    ajaxSpinnerShow = () => {
        document.getElementById("ajaxLoadText").innerHTML = "loading";
        document.getElementById("ajaxShim").style.display = "block";
        document.getElementById("ajaxSpinnerOuter").style.display = "block";
        document.getElementById("ajaxSpinner").style.display = "block";
    }

    ajaxSpinnerHide = () => {
        document.getElementById("ajaxSpinner").style.display = "none";
        document.getElementById("ajaxSpinnerOuter").style.display = "none";
        document.getElementById("ajaxShim").style.display = "none";
    }
    
    hidePopover = () => {
        document.body.click();
    }

    getErrorList = () => {
        let errors = [];
        this.state.errors.forEach((value) => {
            errors.push(
                <div className="rea-block-12 rea-errorMessage">
                    <a href="# " className="rea-link" data-link_to={value.input} onClick={e=>{e.preventDefault();this.navigate();}}>{value.message}</a>
                </div>);
        });
        return errors;
    }

    getErrorListSwap = () => {
        let errors = [];
        this.state.errors.forEach((value) => {
            errors.push(
                <a href="# " className="wth2-formErrorMessage wth2-errorMessageTextOR wth3-errorListItem" id="errorMessageBox" data-link_to={value.input} onClick={e=> {e.preventDefault();this.navigate()}}>{value.message}</a>
            );
        });
        return errors;
    }
    
    navigate = event => {
        const link_to = event.currentTarget.dataset.link_to;
        document.getElementById(link_to) && document.getElementById(link_to).focus();
    }

    handleChangeInput = (e) => {
        const { name, value } = e.target;
        if (name === "confirmationNumberValue") {
            if (value.startsWith(this.state.partnerCode)) {
                this.setState({
                    confirmationNumberAlt: value.replace(/^.*?- /, ''),
                })
                this.setState({
                    [name]: value,
                })
            } else if (value.length > this.state.partnerCode.length) {
                this.setState({
                    confirmationNumberAlt: this.state.partnerCode + value.substring(this.state.partnerCode.length)
                })
                this.setState({
                    [name]: this.state.partnerCode + value.substring(this.state.partnerCode.length)
                })
            }
        } else if (name === 'emailAddressValue') {
            this.setState({
                [name]: value
            })
            this.setState({emailAddressAlt: value})
        } else if (name === 'guestLastNameValue') {
            this.setState({
                [name]: value
            })
            this.setState({guestLastNameAlt: value})
        } 
    }
    
    handleInputFocus = (e) => {
        const { name, value, className, id } = e.target;

        if (className.includes('error')) {
            e.target.classList.remove('error');
            e.target.classList.remove('ng-invalid-required');
            e.target.parentNode.classList.add('active');
            if (id === 'email' || id === 'resendEmail') {
                this.state.errors.delete('emailAddressAlt');
                this.setState({emailAddressValue: ''})
                this.setState({emailAddressAlt: ''})

            } else if (id === 'lastName' || id === 'resendLastName')  {
                this.state.errors.delete('guestLastNameAlt');
                this.setState({guestLastNameValue: ''})
                this.setState({guestLastNameAlt: ''})
                
            }  else if (id === 'bookingNumber')  {
                this.state.errors.delete('confirmationNumberAlt');
                this.setState({confirmationNumberValue: this.state.partnerCode})
                this.setState({confirmationNumberAlt: this.state.partnerCode})
                
            }
         
        } else {
            const elTarget = e.target.parentNode;
            if (elTarget) {
                elTarget.classList.add('active');
                setTimeout(() => {
                    if (name === "confirmationNumberValue") {
                        if (value === '') {
                            this.setState({
                                confirmationNumberValue: this.state.partnerCode
                            })
                        } else {
                            this.setState({
                                confirmationNumberValue: this.state.partnerCode + value.substring(this.state.partnerCode.length)
                            })
                        }
                    }
                }, 500)
            }

        }
    }
    replaceInputWithErrorMessage = () => {
        if (this.state.errors.get('emailAddressAlt') !== undefined) {
            const emailAddressEl = document.getElementById('email') || document.getElementById('resendEmail');
            const elTarget = emailAddressEl.parentNode;
            elTarget.classList.add('active');
            emailAddressEl.classList.add('error');
        }
        if (this.state.errors.get('guestLastNameAlt') !== undefined) {
            const guestLastNameEl = document.getElementById('lastName') || document.getElementById('resendLastName');
            const elTarget = guestLastNameEl.parentNode;
            elTarget.classList.add('active');
            guestLastNameEl.classList.add('error');
        }
        if (this.state.errors.get('confirmationNumberAlt') !== undefined) {
            const confirmationNumberEl = document.getElementById('bookingNumber');
            const elTarget = confirmationNumberEl.parentNode;
            elTarget.classList.add('active');
            confirmationNumberEl.classList.add('error');
        }
    }
    handleInputBlur = (e) => {
        const { name, value } = e.target;
        const elTarget = e.target.parentNode;

        if (name === "confirmationNumberValue") {
            if (this.state.confirmationNumberValue !== this.state.partnerCode) {
                return;
            } else {
                if (this.state.confirmationNumberValue.replace(/^.*?- /, '') === "") {
                    this.setState({
                        confirmationNumberValue: ""
                    })
                    elTarget.classList.remove('active');

                }
            }
        } else  {
            if (value.trim() === "") {
                elTarget.classList.remove('active');
                
            }   
        }
    }
    
    
    
    render = () => {
/*        let shoreExcursionsBullet = '';
        if (this.getStoreAttValue("SHF") === "Y" && this.getStoreAttValue("SHX") !== "") {
            shoreExcursionsBullet = <li className="wth2-cssLogin_content_desc_bullet" id="css_loginBulletShore"><div className="wth2-cssLogin_bulletContent2">Reserve your excursions directly through {this.getStoreAttValue("CFP")}. <a className="link" href={"http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.getStoreAttValue("SHX")} target="_blank" rel="noopener noreferrer" id="shoreExcursionsLink" onclick="callGA('BCSS Login', 'Book Shore Excursions Now', '')">Book Shore Excursions Now</a></div></li>;
        }
        let bcssRescheduleBox = '';
        if (this.getTemplatePropertyValue('BCSS_RESCHEDULE_BOX') === 'Y') {
            bcssRescheduleBox = <p className="wth2-css_resscheduleMargin"><div id="css_rescheduleContainer" className="wth2-css_rescheduleContainer"><div className="wth2-bold">Ready to reschedule your cruise?</div> We don&apos;t want you to miss out! Visit our <a style={{ whiteSpace: 'nowrap' }} data-ajax="false" href={"https://" + this.props.siteConfigData.domainName + this.getTemplatePropertyValue('BCSS_RESCHEDULE_LINK')} id="css-reschedulelink" onClick={() => { this.props.CallTracker('BCSS Login', 'Consultation Form', '') }}>contact us</a> page to provide your contact information and we&apos;ll be in touch shortly!</div></p>;
        }*/
        const Tooltip = () => (
            <Popup
                trigger={open => (
					//eslint-disable-next-line
                    <a href="javascript:void(0);" className="button" tabindex="0" id="whatsThis">What&#39;s This?</a>
                )}
                position="bottom center"
                modal
                nested
                closeOnDocumentClick
            >
                {close => (
					//eslint-disable-next-line
                    <div><a id="whatsThisClose" href="javascript:void(0);" class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right ui-link wth3-popClose" role="button" onClick={close} title="Close"></a><div class="wth3-pop"><h5 id="whatsThisHeader" class="wth3-popuphead">Confirmation Number</h5><p id="whatsThisContent" class="wth3-popupcontent">
                        Your confirmation number consists of 8 digits and can be found in your booking confirmation email.</p></div></div>
                )}
            </Popup>
        );
                
        if (this.props.isSwapSite === false) {
            return (
                <div>
                    <Helmet>
                        <title>Customer Self Service / Login</title>
                    </Helmet>
                    {this.state.errors.size > 0 &&
                        <div className="rea-block-row">
                            <div className="rea-block-12 wth2-errorMessage" id="errorMessageBox">
                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                <div className="rea-block-12 wth2-errorMessageHeader">
                                    Please complete the required fields.
                                </div>

                                {
                                    this.getErrorList()
                                }

                            </div>
                        </div>
                    }
                    <div className="App rea-appContainer rea-backgroundImage">
                        <div className="rea-block-row">
                            <div className="rea-block-12 rea-myResHeader">
                                My Reservation
                            </div>
                        </div>
                        <div className="rea-block-row">
                            <div className="rea-block-4 rea-myResPoints">
                                <p>Get instant access to your reservation without the wait!</p>
                                <ul>
                                    <li>Make Safe and Secure Payments</li>
                                    <li>Review Your Booking</li>
                                </ul>
                            </div>
                            <div className="rea-block-4 rea-verifyContainer">
                                <form onSubmit={this.handleVerifySubmit}>
                                    <div className="form-group">
                                        <div className="form-inline">
                                            <label id="confirmationNumberLabel" htmlFor="confirmationNumber"
                                                className="rea-bold">Order Number:</label>
                                            <OverlayTrigger trigger="click" placement="auto" overlay={this.popover}
                                                rootClose="true">
                                                <button type="button" className="btn rea-infoLink">
                                                    What's this?
                                                </button>
                                            </OverlayTrigger>
                                        </div>

                                        <input type="text" className="form-control"
                                            id="confirmationNumber"
                                            name="confirmationNumber"
                                            value={this.state.confirmationNumber}
                                            onChange={event => {
                                                this.setState({ confirmationNumber: event.target.value })
                                            }}
                                            aria-labelledby="confirmationNumberLabel"
                                            placeholder=""
                                            maxLength="14"
                                            aria-invalid={this.state.errors.get('confirmationNumber') !== undefined}>
                                        </input>

                                        <div className="form-inline">
                                            {
                                                this.state.errors.get('confirmationNumber') &&
                                                <div
                                                    className="rea-errorMessage">{this.state.errors.get('confirmationNumber').message}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label id="emailLabel" htmlFor="email " className="rea-bold">Email
                                            Address</label>
                                        <input type="text" className="form-control"
                                            id="emailAddress"
                                            name="emailAddress"
                                            value={this.state.emailAddress}
                                            onChange={event => {
                                                this.setState({ emailAddress: event.target.value })
                                            }}
                                            aria-labelledby="emailLabel"
                                            placeholder=""
                                            maxLength="100"
                                            aria-invalid={this.state.errors.get('emailAddress') !== undefined}>
                                        </input>
                                        <div className="form-inline">
                                            {
                                                this.state.errors.get('emailAddress') &&
                                                <div
                                                    className="rea-errorMessage">{this.state.errors.get('emailAddress').message}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label id="guestLastNameLabel" htmlFor="guestLastName" className="rea-bold">Guest
                                            Last Name</label>
                                        <input type="text" className="form-control"
                                            id="guestLastName"
                                            name="guestLastName"
                                            value={this.state.guestLastName}
                                            onChange={event => {
                                                this.setState({ guestLastName: event.target.value })
                                            }}
                                            aria-labelledby="guestLastNameLabel"
                                            placeholder=""
                                            maxLength="35"
                                            aria-invalid={this.state.errors.get('guestLastName') !== undefined}>
                                        </input>
                                        <div className="form-inline">
                                            {
                                                this.state.errors.get('guestLastName') &&
                                                <div
                                                    className="rea-errorMessage">{this.state.errors.get('guestLastName').message}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn wth2-ui-btn"
                                            id="submit"
                                            disabled={this.state.accessReservationBookingDisabled}>
                                            Access Your Reservation
                                        </button>
                                        {
                                            this.state.showVerificationErrorMessage &&
                                            <div className="rea-errorMessage">{this.state.verificationErrorMessage}</div>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        // swap 
        else {
            
            return (
                this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N' ? 
                <div className="wth3-login__form-content" id="mainContent" tabindex="-1">
                    

       
                    {this.state.isResendBooking ?

                    this.state.isBookingConfirmation ?
                            
                        <>                     
                            <div className="wth3-login__form-top" id="wth3-mainContent" tabindex="-1">
                                <h2 className="wth3-login__header" id="headerH1">Check your email</h2>
                                <h3 className="wth3-login__sub-header" id="headerP">
                                We've sent all the details straight to your inbox. Be sure to check your email for your confirmation and booking number so you can log in to manage your cruise.
                                </h3>
                            </div>
                            
                            <div className="wth3-login-btn-wrapper btn-wrapper">
                                <button id="wth3-resend-booking" className="wth3-login-form-btn primary-btn" type="button" onClick={this.toggleFormBackToManageMyCruise} value="Resend Email" >Back to manage my cruise</button>
                            </div>

                            <div className="wth3-login__form-bottom" id="wth3-customerSelfService">
                                <a id="resendFormCloseText" className="wth3-login-resend-link link-middle primary-link" onClick={e=>{e.preventDefault();this.toggleResendAndCheckEmailForm();}} tabindex="0" type="submit" href="# ">
                                    Didn't receive it?
                                </a>

                            </div>
                            <>
                            {this.getStoreAttValue("BMV")!=='' && this.getStoreAttValue("BMV")!==null && this.getStoreAttValue("BMV")!=='N' &&
                                <div id="css_rewardContainer" className="wth3-login-faq-container wth3-login-reward-container">
                                    <div className='wth3-login-faq-top wth3-login-reward-top'>
                                        <span className="wth3-login-faq-text">
                                            <a rel="noopener noreferrer" href={this.getExploreDiscountedAddonLink()} id="cssLoginBrandMoversLink" className="wth3-login-reward-link primary-link" target="_blank" onClick={() => { this.props.CallTracker('BCSS Login', 'Brand Movers Link', '') }}>
                                                Book & earn with <span>{this.props.siteConfigData.endorsement}</span> Rewards
                                            </a>
                                        </span>
                                    </div>
                                </div>
	            		    }
                            {this.getStoreAttValue("HLP") !== '' && this.getStoreAttValue("HLP") !== null &&
                            <div id="css_faqContainer" className="wth3-login-faq-container">
                                <div className='wth3-login-faq-top wth3-login-help-top'>
                                    <h1 id="wth2-cssLogin_cssFAQtitle" className="wth3-login-faq-title">Looking for something else?&nbsp;</h1>
                                    <span className="wth3-login-faq-text">
                                        <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth3-login-help-link primary-link" target="_blank" rel="noopener noreferrer" onClick={() => { this.props.CallTracker('BCSS Login', 'Help Center Home', '') }}>
                                            Visit our help center
                                        </a>
                                    </span>
                                </div>
                            </div>
                            }
                            </>   

                        </>   
                    :
                        <>                     
                        <div className="wth3-login__form-top" id="wth3-mainContent" tabindex="-1">
                            <h2 className="wth3-login__header" id="headerH1">Resend confirmation</h2>
                            <h3 className="wth3-login__sub-header" id="headerP">
                                Missing your Booking Confirmation? We've got you covered! Enter the name and email of the lead passenger on your reservation below to receive a copy via email.
                            </h3>
                        </div>
                        <div className="wth3-login__form-bottom" id="wth3-customerSelfService">
                            <div id="wth3-css_loginForm" className="wth2-login__form-wrapper">
                                
                                <div className="wth3-login-button-error-container">
                                    <div className="wth3-login-button-resendNoMatch-error" style={{display: 'none', color: "#AF0C0C", marginBottom: '3rem', lineHeight: '1.375rem'}} tabindex="-1" aria-live="polite">
                                        Sorry, we could not find any bookings associated with
                                        this guest last name and email address. Please give
                                        us a call if you need assistance.
                                    </div>

                                    <div className="wth3-login-button-resendFailure-error" id="errorMessageBoxResend" tabindex="-1" aria-live="polite">
                                    </div>
                                </div>
                                
                                

                                <form name="resendConfirmationEmail" id="resendConfirmationEmailContent" className="wth3-login-form resend-confirmation primary-form" novalidate>
                                    <div className='wth3-login-input-wrapper input-wrapper'>
                                        <div className="wth3-login-input-item input-box-item">
                                            <input className="wth3-login-primary-input primary-input" 
                                                id="resendEmail" 
                                                name="emailAddressValue" 
                                                type='text'
                                                value={this.state.emailAddressValue}
                                                placeholder="" 
                                                maxlength="70" 
                                                size="28" 
                                                onChange={this.handleChangeInput} 
                                                onFocus={this.handleInputFocus}
                                                onBlur={this.handleInputBlur}
                                                aria-labelledby="wth3-login-resendEmail">
                                            </input>
                                        
                                            <label id='wth3-login-resendEmail' className='wth3-login-input-label input-label' for="resendEmail">
                                                Email address
                                            </label>
                                        </div>
                                        <div className="wth3-login-input-item input-box-item">
                                            <input className="wth3-login-primary-input primary-input" 
                                                id="resendLastName" 
                                                name="guestLastNameValue"                                            
                                                value={this.state.guestLastNameValue} 
                                                placeholder="" 
                                                maxlength="28" 
                                                size="28" 
                                                onChange={this.handleChangeInput} 
                                                onFocus={this.handleInputFocus}
                                                onBlur={this.handleInputBlur}
                                                aria-labelledby="wth3-login-resendLastName">

                                            </input>
                                            <label id='wth3-login-resendLastName' className='wth3-login-input-label input-label' for="resendLastName">
                                                Guest last name
                                            </label>
                                        </div>
                                        
                                    </div>


                                    <div className="wth3-login-btn-wrapper btn-wrapper">
                                        <button id="wth3-resend-booking" className="wth3-login-form-btn primary-btn" type="button" onClick={this.handleConfirmationEmailSubmitSwap} value="Resend Email" >Send booking confirmation</button>
                                    </div>
                                </form>
                            </div>

                            <a id="resendFormCloseText" className="wth3-login-resend-link link-middle primary-link" onClick={e=>{e.preventDefault();this.toggleForms()}} tabindex="0" type="submit" href="# ">
                                Back to my reservation
                            </a>
                        </div> 
                        <>
                        {this.getStoreAttValue("BMV")!=='' && this.getStoreAttValue("BMV")!==null && this.getStoreAttValue("BMV")!=='N' &&
                            <div id="css_rewardContainer" className="wth3-login-faq-container wth3-login-reward-container">
                                <div className='wth3-login-faq-top wth3-login-reward-top'>
                                    <span className="wth3-login-faq-text">
                                        <a rel="noopener noreferrer" href={this.getExploreDiscountedAddonLink()} id="cssLoginBrandMoversLink" className="wth3-login-reward-link primary-link" target="_blank" onClick={() => { this.props.CallTracker('BCSS Login', 'Brand Movers Link', '') }}>
                                            Book & earn with <span>{this.props.siteConfigData.endorsement}</span> Rewards
                                        </a>
                                    </span>
                                </div>
                            </div>
                        }
                        {this.getStoreAttValue("HLP") !== '' && this.getStoreAttValue("HLP") !== null &&
                        <div id="css_faqContainer" className="wth3-login-faq-container">
                            <div className='wth3-login-faq-top wth3-login-help-top'>
                                <h1 id="wth2-cssLogin_cssFAQtitle" className="wth3-login-faq-title">Looking for something else?&nbsp;</h1>
                                <span className="wth3-login-faq-text">
                                    <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth3-login-help-link primary-link" target="_blank" rel="noopener noreferrer" onClick={() => { this.props.CallTracker('BCSS Login', 'Help Center Home', '') }}>
                                        Visit our help center
                                    </a>
                                </span>
                            </div>
                        </div>
                        }
                        </>   
                    </>   
                    
                    :
                    <>
                        <div className="wth3-login__form-top" id="wth3-mainContent" tabindex="-1">
                            <h2 className="wth3-login__header" id="headerH1">Manage my cruise</h2>
                            <h3 className="wth3-login__sub-header" id="headerP">
                                Log in to access your cruise booking and payment confirmations, view itinerary details, and make secure payments. You can also add travel insurance, 
                                prepare with our packing lists, book additional rooms, and 
                                <span className="wth3-login__shore-excursion">
                                    <a className="wth3-login-link primary-link" href={"http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.getStoreAttValue("SHX")} target="_blank" rel="noopener noreferrer" id="shoreExcursionsLink" onclick="callGA('BCSS Login', 'Book Shore Excursions Now', '')"> schedule shore excursions.</a>
                                </span>
                            </h3>
                        </div>
                  
                        <div className="wth3-login-button-error-container">
                        {
                            this.state.showVerificationErrorMessage &&
                            <div className="wth3-login-button-error" tabindex="-1" aria-live="polite" style={{color: "#AF0C0C", marginBottom: '3rem', lineHeight: '1.375rem'}}>
                                {this.state.verificationErrorMessage}
                            </div>
                        }
                        {
                            this.props.sessionExpired &&
                            <div ref={(input) => {
                                this.props.sessionExpiredMessage = input;
                            }} className="wth3-login-session-timeout-message" style={{color: "#AF0C0C", marginBottom: '3rem', lineHeight: '1.375rem'}}>
                                We’re sorry. Your session has expired. Please enter your booking details to access
                                your reservation.
                            </div>
                        }

                        </div>
                      
                        <div className="wth3-login__form-bottom" id="wth3-customerSelfService">
                            <div id="wth3-css_loginForm" className="wth2-login__form-wrapper">

                                <form name="cssLogin" id="cssLogin" className="wth3-login-form primary-form" onSubmit={this.handleVerifySubmitSwap} novalidate>
                                    
                                    <div className='wth3-login-input-wrapper input-wrapper'>
                                        <input type="hidden" id="storecode" value='{this.props.siteConfigData.storeCode}'></input>
                
                                        <div className="wth3-login-input-item input-box-item" id="emailAddressBox">
                                            <input 
                                                className={`wth3-login-primary-input primary-input ${this.state.errorClassEmail}`} 
                                                id="email" 
                                                name="emailAddressValue" 
                                                type='text'
                                                value={this.state.emailAddressValue}
                                                placeholder="" 
                                                maxlength="70" 
                                                size="28" 
                                                onChange={this.handleChangeInput} 
                                                onFocus={this.handleInputFocus}
                                                onBlur={this.handleInputBlur}
                                                aria-labelledby="wth3-login-Email" 
                                                aria-invalid={this.state.errors.get('emailAddressAlt') !== undefined}>
                                            </input>
                                            <label className='wth3-login-input-label input-label' for="email" id="wth3-login-Email">Email address</label>
                            
                                        </div>
                                        <div className="wth3-login-input-item input-box-item">
                                                <input 
                                                    type="text" 
                                                    className={`wth3-login-primary-input primary-input ${this.state.errorClassLastName}`} 
                                                    id="lastName" 
                                                    name="guestLastNameValue"                                            
                                                    value={this.state.guestLastNameValue} 
                                                    placeholder="" 
                                                    maxlength="28" 
                                                    size="28" 
                                                    onChange={this.handleChangeInput} 
                                                    onFocus={this.handleInputFocus}
                                                    onBlur={this.handleInputBlur}
                                                    aria-labelledby="wth3-login-LastName" 
                                                    aria-invalid={this.state.errors.get('guestLastNameAlt') !== undefined}>
                                                </input>
                                                <label className='wth3-login-input-label input-label' for="lastName" id="wth3-login-LastName">Guest last name</label>
                                        </div>

                                        <div className="wth3-login-input-item input-box-item">
                                            <input 
                                                type="text" 
                                                className={`wth3-login-primary-input primary-input ${this.state.errorClassBookingNumber}`} 
                                                id="bookingNumber" 
                                                name="confirmationNumberValue" 
                                                placeholder=''
                                                data-mini="true" 
                                                maxlength="14" 
                                                size="28" 
                                                value={this.state.confirmationNumberValue} 
                                                onChange={this.handleChangeInput} 
                                                onFocus={this.handleInputFocus}
                                                onBlur={this.handleInputBlur}
                                                aria-labelledby="wth3-login-ConfNumber" 
                                                aria-invalid={this.state.errors.get('confirmationNumber') !== undefined}>
                                            </input>
                                            <label className='wth3-login-input-label input-label' for="lastName" id="wth3-login-ConfNumber">Confirmation number</label>
                                        
                                        </div>
                                    </div>

                                    { this.getSitePropertyValue('RESEND_BOOKING_CONFIRMATION_EMAIL') === 'Y' &&
                                        <a className="wth3-login-resend-link primary-link" tabindex="0" id="resendConfirmationEmail" onClick={e=>{e.preventDefault();this.toggleForms();}} href="# ">Resend my booking confirmation</a>
                                    }
                                    <div className="wth3-login-btn-wrapper btn-wrapper">
                                        <button id="wth3-cssLoginButton" className="wth3-login-form-btn primary-btn" type="submit" onclick="trackVal()" value="Log In" disabled={this.state.accessReservationBookingDisabled}> 
                                            Go to my reservation
                                        </button>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <>
                        {this.getStoreAttValue("BMV")!=='' && this.getStoreAttValue("BMV")!==null && this.getStoreAttValue("BMV")!=='N' &&
                            <div id="css_rewardContainer" className="wth3-login-faq-container wth3-login-reward-container">
                                <div className='wth3-login-faq-top wth3-login-reward-top'>
                                    <span className="wth3-login-faq-text">
                                        <a rel="noopener noreferrer" href={this.getExploreDiscountedAddonLink()} id="cssLoginBrandMoversLink" className="wth3-login-reward-link primary-link" target="_blank" onClick={() => { this.props.CallTracker('BCSS Login', 'Brand Movers Link', '') }}>
                                            Book & earn with <span>{this.props.siteConfigData.endorsement}</span> Rewards
                                        </a>
                                    </span>
                                </div>
                            </div>
                        }
                        {this.getStoreAttValue("HLP") !== '' && this.getStoreAttValue("HLP") !== null &&
                        <div id="css_faqContainer" className="wth3-login-faq-container">
                            <div className='wth3-login-faq-top wth3-login-help-top'>
                                <h1 id="wth2-cssLogin_cssFAQtitle" className="wth3-login-faq-title">Looking for something else?&nbsp;</h1>
                                <span className="wth3-login-faq-text">
                                    <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth3-login-help-link primary-link" target="_blank" rel="noopener noreferrer" onClick={() => { this.props.CallTracker('BCSS Login', 'Help Center Home', '') }}>
                                        Visit our help center
                                    </a>
                                </span>
                            </div>

                        </div>
                        }
                        </>                              
                    </>
                    }
                </div>
        
             :
  
                <div className="wth2-cssLogin_LoginOuter" id="mainContent" tabindex="-1">
                    <div id="wth2-cssLogin_container">
                        <h2 className="wth2-cssLogin_pageTopH1" id="headerH1">Already Purchased your Cruise?</h2>
                        <h3 className="wth2-cssLogin_pagePTag" id="headerP"> Log In to Access Your Reservation</h3>
                        <div className="wth2-cssLogin_mainContainer">
                            <div id="css_contentContainer2" className="wth2-cssLogin_contentContainer2">
                                <h2 className="wth2-cssLogin_cssSubTitle">
                                    <span id="cssSubTitle" className="wth2-cssLogin_cssSubTitle">Easily access your cruise anytime and anywhere -
                                        conveniently from your laptop or mobile device. You&#39;ll be able to view your booking confirmation, including itinerary details,
                                        summary of charges, and remaining balance. You can also make secure payments, add travel insurance, and&nbsp;
                                        <a className="link" href={"http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.getStoreAttValue("SHX")} target="_blank" rel="noopener noreferrer" id="shoreExcursionsLink" onclick="callGA('BCSS Login', 'Book Shore Excursions Now', '')">book shore excursions.</a></span>
                                </h2>
                            </div>
                            
                           
                            <div id="customerSelfService" className="wth2-css">
                                {/* Resend Form Confirmation: On open/close on resend a tag click */}
                                <div id="css_resendFormContent" className="wth2-cssLogin_cssLoginForm">
                                <div className="resendFormCloseBox">
                                    <a href="# " onClick={e=>{e.preventDefault();this.displayForm()}} id="resendFormCloseText" className="resendFormClose" tabindex="0" type="submit">
                                    close [x]
                                    </a>
                                </div>
                                <div className="rea-block-row">
                                    <div className="rea-block-12 wth2-errorMessage wth2-errorMessageTextOR" id="errorMessageBoxResendValidations" aria-live="polite">
                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                    <div className="rea-block-12 wth2-errorMessageHeader">
                                        &nbsp;Please complete the required fields.
                                    </div>
                                    <div id="wth3-errorList-resend" className="wth3-errorList">
                                        <a href="# " class="wth2-formErrorMessage wth2-errorMessageTextOR wth3-errorListItem" id="lastNameInvalid" data-link_to="resendLastName" onClick={e=>{e.preventDefault();this.focusOnLastName()}}>
                                        Lead Passenger Last Name is not valid
                                        </a>
                                        <a href="# " class="wth2-formErrorMessage wth2-errorMessageTextOR wth3-errorListItem" id="lastNameRequired" data-link_to="resendLastName" onClick={e=>{e.preventDefault();this.focusOnLastName()}}>
                                        Lead Passenger Last Name is required
                                        </a>
                                        <a href="# " class="wth2-formErrorMessage wth2-errorMessageTextOR wth3-errorListItem" id="emailInvalid" data-link_to="resendEmail" onClick={e=>{e.preventDefault();this.focusOnEmail()}}>
                                        Lead Passenger Email Address is not valid
                                        </a>
                                        <a href="# " class="wth2-formErrorMessage wth2-errorMessageTextOR wth3-errorListItem" id="emailRequired" data-link_to="resendEmail" onClick={e=>{e.preventDefault();this.focusOnEmail()}}>
                                        Lead Passenger Email Address is required
                                        </a>
                                    </div>
                                    </div>
                                </div>

                                <div className="rea-block-row">
                                    <div className="rea-block-12 wth2-errorMessage wth2-errorMessageTextOR" id="errorMessageBoxResend" aria-live="polite">
                                    <div className="rea-block-12 wth2-errorMessageHeader">
                                        Sorry, we could not find any bookings associated with
                                        this lead passenger name and email address. Please give
                                        us a call if you need assistance.
                                    </div>
                                    </div>
                                </div>

                                <div className="rea-block-row">
                                    <div className="rea-block-12 wth2-errorMessage wth2-errorMessageTextOR" id="failureMessageBoxResend" aria-live="polite">
                                    <div className="rea-block-12 wth2-errorMessageHeader" id="failureMessageBoxResendContent"></div>
                                    </div>
                                </div>
                                <div id="resendConfirmationHeaderBox" class="wth4-popuphead-box">
                                    <h5 id="resendConfirmationEmailHeader" class="wth4-popuphead">
                                    Can&#39;t find your confirmation email?{" "}
                                    </h5>
                                    <p>
                                    Enter your name and email below to receive a copy via
                                    email.
                                    </p>
                                </div>
                                <form name="resendConfirmationEmail" id="resendConfirmationEmailContent" className="wth2-form wth2-cssLogin_Form" novalidate>
                                <div className="form-group ui-block-a sPadTop">
                                    <label for="resendLastName" id="css_resendLastName">
                                        Lead Passenger Last Name:
                                    </label>
                                    <div className="wth2-inputWrap">
                                        <input type="text" className="form-control wth2-inputText" id="resendLastName" name="resendLastName" placeholder="" maxlength="28" size="28" aria-labelledby="css_resendLastName"></input>
                                    </div>
                                    </div>
                                    <div className="form-group ui-block-a sPadTop">
                                    <label for="resendEmail" id="css_resendEmail">
                                        Lead Passenger Email Address:
                                    </label>
                                    <div className="wth2-inputWrap">
                                        <input className="form-control wth2-inputText" id="resendEmail" name="resendEmail" placeholder="" maxlength="70" size="28" aria-labelledby="css_resendEmail"></input>
                                        <p id="resendFormEmailHint" className="wth2-cssLogin_cssEmailHint wth2-formHint">
                                        email@sample.com
                                        </p>
                                    </div>
                                    </div>

                                    <div className="wth2-cssbutton ssPadTop wth4-resendEmail">
                                    	<button id="resendConfirmationEmailButton" className="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" type="button" onClick={this.handleConfirmationEmailSubmitSwap} value="Resend Email" > Submit </button>
                                    </div>
                                </form>

                                <div className="rea-block-row" id="successMessageBoxResendWrapper">
                                    <div className="rea-block-12 wth2-sucessMessage" id="successMessageBoxResend" aria-live="polite">
                                    <div className="rea-block-12 wth2-sucessMessageHeader">
                                        Thank you for your request. You will soon receive a
                                        booking confirmation email for each of your upcoming
                                        sailings.
                                    </div>
                                    </div>
                                </div>
                                </div>

                                {/* Main form and Video container */}
                            	<div id="css_container">
                                    <div id="css_loginForm" className="wth2-cssLogin_cssLoginForm">
                                        {this.state.errors.size > 0 &&
                                            <div className="rea-block-row">
                                                <div className="rea-block-12 wth2-errorMessage wth2-errorMessageTextOR" id="errorMessageBox" aria-live="polite">
                                                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                    <div className="rea-block-12 wth2-errorMessageHeader">
                                                        Please complete the required fields.
                                                    </div>
                                                    <div id="wth3-errorList" className="wth3-errorList">
                                                        {
                                                            this.getErrorListSwap()
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            this.state.showVerificationErrorMessage &&
                                            <div className="rea-block-row">
                                                <div className="rea-block-12 wth2-errorMessage wth2-errorMessageTextOR" id="errorMessageBox" aria-live="polite">
                                                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                    <div className="rea-block-12 wth2-errorMessageHeader">We&#39;re sorry.</div>
                                                    <div>
                                                        {this.state.verificationErrorMessage}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <form name="cssLogin" id="cssLogin" className='wth2-form wth2-cssLogin_Form' onSubmit={this.handleVerifySubmitSwap} novalidate>
                                            <input type="hidden" id="storecode" value='{this.props.siteConfigData.storeCode}'></input>
                                            <div className="form-group ui-block-a sPadTop">
                                                <label for="bookingNumber" id="css_loginConfNumber">{this.getStoreAttValue('CFP')} Confirmation Number: <Tooltip /></label>
                                                <div className="wth2-inputWrap"><div id="wth2-partnerCode">{this.props.siteConfigData.store.partnerCode} -&nbsp;</div><div id="wth2-bookingNumber"><input type="text" className={`form-control wth2-inputText ${this.state.errorClassBookingNumber}`} id="bookingNumber" name="bookingNumber" placeholder="" data-mini="true" maxlength="14" size="28" value={this.state.confirmationNumber} onChange={event => { this.setState({ confirmationNumber: event.target.value }) }} aria-labelledby="css_loginConfNumber" aria-invalid={this.state.errors.get('confirmationNumber') !== undefined}></input></div></div>
                                            </div>
                                            
                                            { this.getSitePropertyValue('RESEND_BOOKING_CONFIRMATION_EMAIL') === 'Y' &&
                                            	<a className="button" tabindex="0" id="resendConfirmationEmail" onClick={e=>{e.preventDefault();this.displayForm()}} href="# ">Resend My Booking Confirmation Email</a>
                                            }
                                            
                                            <div className="form-group ui-block-a sPadTop">
                                                <label for="email" id="css_loginEmail">Email Address:</label>
                                                <div className="wth2-inputWrap"><input className={`form-control wth2-inputText ${this.state.errorClassEmail}`} id="email" name="email" placeholder="" maxlength="70" size="28" onChange={event => { this.setState({ emailAddress: event.target.value }) }} aria-labelledby="css_loginEmail" aria-invalid={this.state.errors.get('emailAddress') !== undefined}></input></div>
                                                <p id="confirmationFormEmailHint" className="wth2-cssLogin_cssEmailHint wth2-formHint">youremail@sample.com</p>
                                            </div>
                                            <div className="form-group ui-block-a">
                                                <label for="lastName" id="css_loginLastName">Guest Last Name:</label>
                                                <div className="wth2-inputWrap"><input type="text" className={`form-control wth2-inputText ${this.state.errorClassLastName}`} id="lastName" name="lastName" placeholder="" maxlength="28" size="28" value={this.state.guestLastName} onChange={event => { this.setState({ guestLastName: event.target.value }) }} aria-labelledby="css_loginLastName" aria-invalid={this.state.errors.get('guestLastName') !== undefined}></input></div>
                                            </div>
                                            <div className="wth2-cssbutton ui-block-a ssPadTop">
                                                <button id="cssLoginButton" className="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" type="submit" onclick="trackVal()" value="Log In" disabled={this.state.accessReservationBookingDisabled}> Log In </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div id="css_contentContainer2" className="wth2-cssLogin_show-on-mobile hide-on-desktop">
                                        <h2 className="wth2-cssLogin_cssSubTitle">
                                            <span id="cssSubTitle" className="wth2-cssLogin_cssSubTitle">Easily access your cruise anytime and anywhere -
                                                conveniently from your laptop or mobile device. You&#39;ll be able to view your booking confirmation, including itinerary details,
                                                summary of charges, and remaining balance. You can also make secure payments, add travel insurance, and &nbsp;
                                                <a className="link" href={"http://www.shoreexcursionsgroup.com/v/affiliate/?id=" + this.getStoreAttValue("SHX")} target="_blank" rel="noopener noreferrer" id="shoreExcursionsLink" onclick="callGA('BCSS Login', 'Book Shore Excursions Now', '')">book shore excursions</a></span>
                                        </h2>
                                    </div>
                                    <div id="css_embed-container" className="embed-container">
                                        {
                                            this.props.siteConfigData.storeCode === 'BCWEB' ? 
                                                <iframe src="https://player.vimeo.com/video/880212153?badge=0&amp;autopause=0&amp;quality_selector=1&amp;player_id=0&amp;app_id=58479&amp;title=false&amp;portrait=false&amp;byline=false" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute", top:"0", left:"0", width:"100%", height:"100%"}} title="Booking.com Customer Portal"></iframe>
                                            : this.props.siteConfigData.storeCode === 'CHCRW' ? 
                                                <iframe src="https://player.vimeo.com/video/794130666?h=d8bafb8bf6&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;title=false&amp;portrait=false&amp;byline=false" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute", top:"0", left:"0", width:"100%", height:"100%"}} title="Cheap Cruises Customer Portal"></iframe>          
                                            : this.props.siteConfigData.storeCode === 'PLWEB' ?
                                                <iframe src="https://player.vimeo.com/video/794129357?h=2703a9713f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;title=false&amp;portrait=false&amp;byline=false" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute", top:"0", left:"0", width:"100%", height:"100%"}} title="Priceline Customer Portal"></iframe>
                                            : this.props.siteConfigData.storeCode === 'CDCNW' ?
                                                <iframe src="https://player.vimeo.com/video/793483776?h=58e2c4a202&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;title=false&amp;portrait=false&amp;byline=false" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute", top:"0", left:"0", width:"100%", height:"100%"}} title="Cruises.com Customer Portal"></iframe>
                                            : 
                                                <iframe src="https://player.vimeo.com/video/789832652?h=66aee90d35&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;title=false&amp;portrait=false&amp;byline=false" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{position:"absolute", top:"0", left:"0", width:"100%", height:"100%"}} title="Already Booked"></iframe>
                                             
                                        }
                                    </div>
                                </div>
                                <div className="ab">
                                 {this.getStoreAttValue("HLP") !== '' && this.getStoreAttValue("HLP") !== null &&
                                    <div id="css_faqContainer" className="wth2-cssLogin_cssFAQcontainer">
                                        <h1 id="wth2-cssLogin_cssFAQtitle" className="wth2-cssLogin_faqTitle">Looking for Answers?&nbsp;
                                            <span className="wth2-cssLogin_faqText">Visit our&nbsp;

                                                <a href={this.getStoreAttValue("HLP")} id="cssHelpCenterButton" className="wth2-cssLogin_helpLinks" target="_blank" rel="noopener noreferrer" onClick={() => { this.props.CallTracker('BCSS Login', 'Help Center Home', '') }}>Help Center</a>
                                                &nbsp;or choose a category below.
                                            </span>
                                        </h1>
                                        <div id="faqButtonContainerWrapper">
                                            <FaqButtonService siteConfigData={this.siteConfigData}>
                                            </FaqButtonService>
                                        </div>
                                    </div>
                                }
                                </div>                              
                            </div>
                        </div>

                    </div>
                </div>

            )
        }
    }

    focusError = (focusElement) => {
        document.getElementById(focusElement).focus();
    }
    // custom validations...

    validateConfirmationNumberSwap = () => {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') { 
            const value = this.state.confirmationNumberAlt.replace(/^.*?- /, '').trim();
            let errors = this.state.errors;
            errors.delete('confirmationNumberAlt');
            let valid = true;
            if (value.length === 0) {
                this.setState({ errorClassBookingNumber: 'ng-invalid-required' });
                errors.set('confirmationNumberAlt', {
                    input: 'bookingNumber',
                    message: 'Confirmation number is required'
                });
                valid = false;
            } else {
                if (!/^(\d+-?)+\d{5,14}$/.test(value)) {
                    this.setState({ errorClassBookingNumber: 'ng-invalid-required' });
                    errors.set('confirmationNumberAlt', {
                        input: 'bookingNumber',
                        message: 'Confirmation number is not valid'
                    });
                    valid = false;
                }
            }
            this.setState({ errors: errors });

            return valid;

        } else {
            const value = this.state.confirmationNumber.trim();
            let errors = this.state.errors;
            errors.delete('confirmationNumber');
            let valid = true;
            if (value.length === 0) {
                this.setState({ errorClassBookingNumber: 'ng-invalid-required' });
                errors.set('confirmationNumber', {
                    input: 'bookingNumber',
                    message: 'Confirmation Number is required'
                });
                valid = false;
            } else {
                if (!/^(\d+-?)+\d{5,14}$/.test(value)) {
                    this.setState({ errorClassBookingNumber: 'ng-invalid-required' });
                    errors.set('confirmationNumber', {
                        input: 'bookingNumber',
                        message: 'Confirmation Number is not valid'
                    });
                    valid = false;
                }
            }
            this.setState({ errors: errors });
            if (this.state.errors.get('guestLastName') !== undefined || this.state.errors.get('confirmationNumber') !== undefined || this.state.errors.get('emailAddress') !== undefined) {
                setTimeout(() => {
                    if (document.getElementById("wth3-errorList")) {
                        document.getElementById("wth3-errorList").firstChild.focus();
                    }
                }, 500);


            }
            return valid;
        }
    };

    validateConfirmationNumber = () => {
        const value = this.state.confirmationNumber;
        let errors = this.state.errors;
        errors.delete('confirmationNumber');
        let valid = true;
        if (value.length === 0) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("confirmationNumber").focus();
            }
            errors.set('confirmationNumber', {
                input: 'confirmationNumber',
                message: 'Order Number is required'
            });
            valid = false;
        } else {
            if (!/^\d+$/.test(value)) {
                errors.set('confirmationNumber', {
                    input: 'confirmationNumber',
                    message: 'Order Number is not valid'
                });
                valid = false;
            }
        }
        this.setState({ errors: errors });
        return valid;
    };

    validateEmailSwap() {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            const value = this.state.emailAddressAlt;
            let errors = this.state.errors;
            errors.delete('emailAddressAlt');
            let valid = true;
            if (value.length === 0) {
                this.setState({ errorClassEmail: 'ng-invalid-required' });
                errors.set('emailAddressAlt', {
                    input: 'email',
                    message: 'Email address is required'
                });
                valid = false;
            } else {
                let regex = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}/;
                if (!regex.test(value)) {
                    this.setState({ errorClassEmail: 'ng-invalid-required' });
                    errors.set('emailAddressAlt', {
                        input: 'email',
                        message: 'Email address is not valid'
                    });
                    valid = false;
                }
            }
    
            this.setState({ errors: errors });
    
            return valid;

        } else {
            const value = this.state.emailAddress;
            let errors = this.state.errors;
            errors.delete('emailAddress');
            let valid = true;
            if (value.length === 0) {
                this.setState({ errorClassEmail: 'ng-invalid-required' });
                errors.set('emailAddress', {
                    input: 'email',
                    message: 'Email Address is required'
                });
                valid = false;
            } else {
                let regex = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}/;
                //if (!/^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(value)) {
                if (!regex.test(value)) {
                    this.setState({ errorClassEmail: 'ng-invalid-required' });
                    errors.set('emailAddress', {
                        input: 'email',
                        message: 'Email Address is not valid'
                    });
                    valid = false;
                }
            }
    
            this.setState({ errors: errors });
            if (this.state.errors.get('guestLastName') !== undefined || this.state.errors.get('confirmationNumber') !== undefined || this.state.errors.get('emailAddress') !== undefined) {
                setTimeout(() => {
                    if (document.getElementById("wth3-errorList")) {
                        document.getElementById("wth3-errorList").firstChild.focus();
                    }
                }, 500);
    
    
            }
    
            return valid;
        }
    }
    
    validateResendEmailSwap() {
            const value = document.getElementById("resendEmail").value;
            let valid = true;
            if (value.length === 0) {
                document.getElementById('errorMessageBoxResendValidations').style.display = "block";
                document.getElementById("resendEmail").setAttribute("aria-invalid", false);
                document.getElementById("resendEmail").classList.add("wth4-invalid-required");
                document.getElementById('emailRequired').style.display = "block";
                document.getElementById('emailRequired').focus();
                valid = false;
            } else {
                let regex = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}/;
                if (!regex.test(value)) {
                    document.getElementById('errorMessageBoxResendValidations').style.display = "block";
                    document.getElementById("resendEmail").setAttribute("aria-invalid", false);
                    document.getElementById("resendEmail").classList.add("wth4-invalid-required");
                    document.getElementById('emailInvalid').style.display = "block";
                    document.getElementById('emailInvalid').focus();
                    valid = false;
                }
            }
            return valid;
    }

    validateEmail() {
        const value = this.state.emailAddress;
        let errors = this.state.errors;
        errors.delete('emailAddress');
        let valid = true;
        if (value.length === 0) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("emailAddress").focus();
            }
            errors.set('emailAddress', {
                input: 'emailAddress',
                message: 'Email Address is required'
            });
            valid = false;
        } else {
            let regex = /[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}/;
            //if (!/^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(value)) {
            if (!regex.test(value)) {
                if (!this.htmlElementFocused) {
                    this.htmlElementFocused = true;
                    document.getElementById("emailAddress").focus();
                }
                errors.set('emailAddress', {
                    input: 'emailAddress',
                    message: 'Email Address is not valid'
                });
                valid = false;
            }
        }

        this.setState({ errors: errors });

        return valid;
    }

    validateLastNameSwap() {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            const value = this.state.guestLastNameAlt;
            let errors = this.state.errors;
            errors.delete('guestLastNameAlt');
            let valid = true;
            if (value.length === 0) {
                //todo tracking calls externally
                this.setState({ errorClassLastName: 'ng-invalid-required' });
                errors.set('guestLastNameAlt', {
                    input: 'lastName',
                    message: 'Guest last name is required'
                });
                valid = false;
            } else {
                if (!/^[a-z ,.'-]+$/i.test(value)) {
                    this.setState({ errorClassLastName: 'ng-invalid-required' });
                    errors.set('guestLastNameAlt', {
                        input: 'lastName',
                        message: 'Guest last name is not valid'
                    });
                    valid = false;
                }
            }
            this.setState({ errors: errors });

            return valid;
        } else {
            const value = this.state.guestLastName;
            let errors = this.state.errors;
            errors.delete('guestLastName');
            let valid = true;
            if (value.length === 0) {
                //todo tracking calls externally
                this.setState({ errorClassLastName: 'ng-invalid-required' });
                errors.set('guestLastName', {
                    input: 'lastName',
                    message: 'Guest Last Name is required'
                });
                valid = false;
            } else {
                if (!/^[a-z ,.'-]+$/i.test(value)) {
                    this.setState({ errorClassLastName: 'ng-invalid-required' });
                    errors.set('guestLastName', {
                        input: 'lastName',
                        message: 'Guest Last Name is not valid'
                    });
                    valid = false;
                }
            }
            this.setState({ errors: errors });
            if (this.state.errors.get('guestLastName') !== undefined || this.state.errors.get('confirmationNumber') !== undefined || this.state.errors.get('emailAddress') !== undefined) {
                setTimeout(() => {
                    if (document.getElementById("wth3-errorList")) {
                        document.getElementById("wth3-errorList").firstChild.focus();
                    }
                }, 500);
    
    
            }
            return valid;
        }
    }
    
    validateResendLastNameSwap() {
        const value = document.getElementById("resendLastName").value
        let valid = true;
        if (value.length === 0) {
        	document.getElementById('errorMessageBoxResendValidations').style.display = "block";
        	document.getElementById("resendLastName").setAttribute("aria-invalid", false);
        	document.getElementById("resendLastName").classList.add("wth4-invalid-required");
        	document.getElementById('lastNameRequired').style.display = "block";
        	document.getElementById('lastNameRequired').focus();
            valid = false;        
        } 
        else {
            if (!/^[a-z ,.'-]+$/i.test(value)) {
            	document.getElementById('errorMessageBoxResendValidations').style.display = "block";
            	document.getElementById("resendLastName").setAttribute("aria-invalid", false);
            	document.getElementById("resendLastName").classList.add("wth4-invalid-required");
            	document.getElementById('lastNameInvalid').style.display = "block";
            	document.getElementById('lastNameInvalid').focus();
                valid = false;
            }
        }
        return valid;
    }

    validateLastName() {
        const value = this.state.guestLastName;
        let errors = this.state.errors;
        errors.delete('guestLastName');
        let valid = true;
        if (value.length === 0) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("guestLastName").focus();
            }
            errors.set('guestLastName', {
                input: 'guestLastName',
                message: 'Guest Last Name is required'
            });
            valid = false;
        } else {
            if (!/^[a-z ,.'-]+$/i.test(value)) {
                if (!this.htmlElementFocused) {
                    this.htmlElementFocused = true;
                    document.getElementById("guestLastName").focus();
                }
                errors.set('guestLastName', {
                    input: 'guestLastName',
                    message: 'Guest Last Name is not valid'
                });
                valid = false;
            }
        }
        this.setState({ errors: errors });
        return valid;
    }

    formIsValid() {
        this.htmlElementFocused = false;
        let confirmationNumber = this.validateConfirmationNumber();
        let email = this.validateEmail();
        let lastName = this.validateLastName();
        return confirmationNumber && email && lastName;
    }

    formIsValidSwap() {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            let email = this.validateEmailSwap();
            let lastName = this.validateLastNameSwap();
            let confirmationNumber = this.validateConfirmationNumberSwap();

            setTimeout(() => {
                if (this.state.errors.get('emailAddressAlt') !== undefined) {
                    this.setState({emailAddressValue: this.state.errors.get("emailAddressAlt").message});
                    this.replaceInputWithErrorMessage();
                }
                if (this.state.errors.get('guestLastNameAlt') !== undefined) {
                    this.setState({guestLastNameValue: this.state.errors.get("guestLastNameAlt").message});
                    this.replaceInputWithErrorMessage();
                }
                if (this.state.errors.get('confirmationNumberAlt') !== undefined) {
                    this.setState({confirmationNumberValue: this.state.errors.get("confirmationNumberAlt").message});
                    this.replaceInputWithErrorMessage();
                }

            }, 500);
    
    
            return email && lastName && confirmationNumber;

        } else {
            document.getElementById("wth2-cssLogin_container").style.height = "auto";
            this.htmlElementFocused = false;
            let confirmationNumber = this.validateConfirmationNumberSwap();
            let email = this.validateEmailSwap();
            let lastName = this.validateLastNameSwap();
            if (this.state.errors.get('guestLastName') !== undefined || this.state.errors.get('confirmationNumber') !== undefined || this.state.errors.get('emailAddress') !== undefined) {
                setTimeout(() => {
                    let errorBoxHeight = document.getElementById("errorMessageBox").offsetHeight;
                    let contentContainerHeight = document.getElementById("wth2-cssLogin_container").offsetHeight;
                    let combinedHeight = contentContainerHeight + errorBoxHeight + 25;
                    document.getElementById("wth2-cssLogin_container").style.height = combinedHeight + "px";
                }, 500);
    
    
            }
            return confirmationNumber && email && lastName;
        }
    }
    
    resendFormIsValidSwap() {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            let email = this.validateEmailSwap();
            let lastName = this.validateLastNameSwap();
            setTimeout(() => {
                if (this.state.errors.get('emailAddressAlt') !== undefined) {
                    this.setState({emailAddressValue: this.state.errors.get("emailAddressAlt").message});
                    this.replaceInputWithErrorMessage();
                }
                if (this.state.errors.get('guestLastNameAlt') !== undefined) {
                    this.setState({guestLastNameValue: this.state.errors.get("guestLastNameAlt").message});
                    this.replaceInputWithErrorMessage();
                }

            }, 500);
    
            return email && lastName;
        } else {
            this.resetValidationErrors();
            document.getElementById("css_resendFormContent").style.height = "auto";
            this.htmlElementFocused = false;
            let email = this.validateResendEmailSwap();
            let lastName = this.validateResendLastNameSwap();
            return email && lastName;
        }
      }

    
    resetValidationErrors() {
    	document.getElementById('errorMessageBoxResendValidations').style.display = "none";
    	document.getElementById('lastNameInvalid').style.display = "none";
    	document.getElementById('lastNameRequired').style.display = "none";
    	document.getElementById('emailInvalid').style.display = "none";
    	document.getElementById('emailRequired').style.display = "none";
    	document.getElementById("resendLastName").setAttribute("aria-invalid", true);
    	document.getElementById("resendLastName").classList.remove("wth4-invalid-required");
    	document.getElementById("resendEmail").setAttribute("aria-invalid", true);
    	document.getElementById("resendEmail").classList.remove("wth4-invalid-required");
    	document.getElementById('errorMessageBoxResend').style.display = "none";
    	document.getElementById('failureMessageBoxResend').style.display = "none";
    	document.getElementById('successMessageBoxResend').style.display = "none";
    }
    
    focusOnLastName() {
    	document.getElementById("resendLastName").focus();
    }
    
    focusOnEmail() {
    	document.getElementById("resendEmail").focus();
    }
    
    focusOnCloseButton() {
    	document.getElementById("resendFormCloseText").focus();
    }
    
    // end of custom validations...

    handleVerifySubmitSwap = (event) => {
        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            event.preventDefault();
            this.setState({ errorClassBookingNumber: '' });
            this.setState({ errorClassEmail: '' });
            this.setState({ errorClassLastName: '' });
            if (this.formIsValidSwap()) {
                this.ajaxSpinnerShow();
                this.setState({ accessReservationBookingDisabled: true });
                console.debug('Verifying booking...');
                let url = '/wthrest/customer-self-service/verifyBooking.rs';
                let payload = {
                    "lastName": this.state.guestLastNameAlt.trim(),
                    "email": this.state.emailAddressAlt.trim(),
                    "bookingNumber": this.state.confirmationNumberAlt.trim().replace(/^.*?- /, '')
                };
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }).then(verificationResponse => verificationResponse.json()).then(jsonVerificationResponse => {
                    this.setState({ 'showVerificationErrorMessage': !jsonVerificationResponse.loginStatus });
    
                    if (!jsonVerificationResponse.loginStatus) {
                        this.ajaxSpinnerHide();
                        let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                        console.log(jsonVerificationResponse.errorCode);
                        if (jsonVerificationResponse.message === 'The information provided does not match a booking. Please try again.') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Page Alert", "We could not locate a reservation");
                            this.setState({
                                'verificationErrorMessage': 'The information provided does not match a booking. Please try again or call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
                        }
                        else if (jsonVerificationResponse.bookingStatus === 'RE') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "reserve error status");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.bookingStatus === 'CC') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "cancelled status");
                            this.setState({
                                'verificationErrorMessage': 'This reservation has been cancelled. Please call ' + mainPhoneNumber + '  if you need assistance from a cruise expert.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('NONE_CRUISE_BOOKING')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Non-cruise booking");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('WRONG_SITE')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Login attempt on wrong site");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('PASSENGER_INFO')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Passenger Information incorrect");
                            this.setState({
                                'verificationErrorMessage': 'The guest email address or last name does not match our records. Please try again or call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('INTERNAL_ERROR')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Inquiry status or invalid confirmation");
                            this.setState({
                                'verificationErrorMessage': 'The information provided does not match a booking. Please try again or call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
                        }
    
                        else {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", jsonVerificationResponse.message);
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
                        }
    
                        document.querySelector('.wth3-login-container').style.minHeight = '51.3125rem';
                        document.querySelector('.wth3-login__sub-header').style.marginBottom = '2rem';
                        this.props.sessionExpired = false;
                        this.props.sessionExpiredMessage = null;
                        document.querySelector('.wth3-login-button-error').focus();
                        this.setState({ accessReservationBookingDisabled: false });
                    } else {
                        console.debug('getting booking...');
                        this.ajaxSpinnerShow();
                        url = '/wthrest/customer-self-service/getBooking.rs';
                        payload = {
                            "bookingNumber": this.state.confirmationNumberAlt.trim(),
                            "hash": jsonVerificationResponse.hash
                        }
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => {
                            this.ajaxSpinnerHide();
                            this.setState({ accessReservationBookingDisabled: false });
                            this.props.CallTracker('Customer Self Service', 'Login', '');
                            this.props.onBookingRetrieved(jsonBookingResponse, jsonVerificationResponse.hash);
                        }).catch(error => {
                            this.ajaxSpinnerHide();
                            this.setState({ accessReservationBookingDisabled: false });
                            this.setState({ 'showVerificationErrorMessage': true });

                            let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });

                        });
    
                    }
                }).catch(error => {
                    this.ajaxSpinnerHide();
                    this.setState({ accessReservationBookingDisabled: false });
                    this.setState({ 'showVerificationErrorMessage': true });
                    let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                    //TODO  make errors more specific
                    this.setState({
                        'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                    });

                });
            }

        } else {
            event.preventDefault();
            this.setState({ errorClassBookingNumber: '' });
            this.setState({ errorClassEmail: '' });
            this.setState({ errorClassLastName: '' });
            if (this.formIsValidSwap()) {
                this.ajaxSpinnerShow();
                this.setState({ accessReservationBookingDisabled: true });
                console.debug('Verifying booking...');
                let url = '/wthrest/customer-self-service/verifyBooking.rs';
                let payload = {
                    "lastName": this.state.guestLastName.trim(),
                    "email": this.state.emailAddress.trim(),
                    "bookingNumber": this.state.confirmationNumber.trim()
                };
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }).then(verificationResponse => verificationResponse.json()).then(jsonVerificationResponse => {
                    this.setState({ 'showVerificationErrorMessage': !jsonVerificationResponse.loginStatus });
    
                    if (!jsonVerificationResponse.loginStatus) {
                        this.ajaxSpinnerHide();
                        let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                        console.log(jsonVerificationResponse.errorCode);
                        if (jsonVerificationResponse.message === 'The information provided does not match a booking. Please try again.') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Page Alert", "We could not locate a reservation");
                            this.setState({
                                'verificationErrorMessage': 'The information provided does not match a booking. Please try again or call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
                        }
                        else if (jsonVerificationResponse.bookingStatus === 'RE') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "reserve error status");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.bookingStatus === 'CC') {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "cancelled status");
                            this.setState({
                                'verificationErrorMessage': 'This reservation has been cancelled. Please call ' + mainPhoneNumber + '  if you need assistance from a cruise expert.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('NONE_CRUISE_BOOKING')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Non-cruise booking");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('WRONG_SITE')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Login attempt on wrong site");
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('PASSENGER_INFO')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Passenger Information incorrect");
                            this.setState({
                                'verificationErrorMessage': 'The guest email address or last name does not match our records. Please try again or call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
    
                        }
                        else if (jsonVerificationResponse.errorCode.includes('INTERNAL_ERROR')) {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", "Inquiry status or invalid confirmation");
                            this.setState({
                                'verificationErrorMessage': 'The information provided does not match a booking. Please try again or call ' + mainPhoneNumber + ' to speak with a travel expert who will happily assist you.'
                            });
                        }
    
                        else {
                            this.ajaxSpinnerHide();
                            this.props.CallTracker("Customer Self Service", "Errors", jsonVerificationResponse.message);
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
                        }
                        let errorBoxHeight = document.getElementById("errorMessageBox").offsetHeight;
                        let contentContainerHeight = document.getElementById("wth2-cssLogin_container").offsetHeight;
                        let combinedHeight = contentContainerHeight + errorBoxHeight + 25;
                        document.getElementById("wth2-cssLogin_container").style.height = combinedHeight + "px";
    
                        this.setState({ accessReservationBookingDisabled: false });
                    } else {
                        console.debug('getting booking...');
                        this.ajaxSpinnerShow();
                        url = '/wthrest/customer-self-service/getBooking.rs';
                        payload = {
                            "bookingNumber": this.state.confirmationNumber.trim(),
                            "hash": jsonVerificationResponse.hash
                        }
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => {
                            this.ajaxSpinnerHide();
                            this.setState({ accessReservationBookingDisabled: false });
                            this.props.CallTracker('Customer Self Service', 'Login', '');
                            this.props.onBookingRetrieved(jsonBookingResponse, jsonVerificationResponse.hash);
                        }).catch(error => {
                            this.ajaxSpinnerHide();
                            this.setState({ accessReservationBookingDisabled: false });
                            this.setState({ 'showVerificationErrorMessage': true });
                            //this.setState({'verificationErrorMessage': error.toString()});
                            //TODO make errors more specific
                            let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                            this.setState({
                                'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                            });
                            let errorBoxHeight = document.getElementById("errorMessageBox").offsetHeight;
                            let contentContainerHeight = document.getElementById("wth2-cssLogin_container").offsetHeight;
                            let combinedHeight = contentContainerHeight + errorBoxHeight + 25;
                            document.getElementById("wth2-cssLogin_container").style.height = combinedHeight + "px";
                        });
    
                    }
                }).catch(error => {
                    this.ajaxSpinnerHide();
                    this.setState({ accessReservationBookingDisabled: false });
                    this.setState({ 'showVerificationErrorMessage': true });
                    let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                    //TODO  make errors more specific
                    this.setState({
                        'verificationErrorMessage': 'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with a cruise expert who will happily assist you.'
                    });
                    let errorBoxHeight = document.getElementById("errorMessageBox").offsetHeight;
                    let contentContainerHeight = document.getElementById("wth2-cssLogin_container").offsetHeight;
                    let combinedHeight = contentContainerHeight + errorBoxHeight + 25;
                    document.getElementById("wth2-cssLogin_container").style.height = combinedHeight + "px";
                });
            }
        }


    }


    handleVerifySubmit = (event) => {
        event.preventDefault();
        if (this.formIsValid()) {

            this.setState({ accessReservationBookingDisabled: true });
            console.debug('Verifying booking...');
            let url = '/wthrest/customer-self-service/verifyBooking.rs';
            let payload = {
                "lastName": this.state.guestLastName.trim(),
                "email": this.state.emailAddress.trim(),
                "bookingNumber": this.state.confirmationNumber.trim()
            };

            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(verificationResponse => verificationResponse.json()).then(jsonVerificationResponse => {
                this.setState({ 'showVerificationErrorMessage': !jsonVerificationResponse.loginStatus });

                if (!jsonVerificationResponse.loginStatus) {
                    let mainPhoneNumber = this.props.franchiseData.mainPhoneNumber;
                    this.setState({
                        'verificationErrorMessage': 'We’re sorry.\n' +
                            'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with your vacation specialist for assistance.'
                    });
                    this.setState({ accessReservationBookingDisabled: false });
                } else {
                    console.debug('getting booking...');
                    url = '/wthrest/customer-self-service/getBooking.rs';
                    payload = {
                        "bookingNumber": this.state.confirmationNumber,
                        "hash": jsonVerificationResponse.hash
                    }
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    }).then(bookingResponse => bookingResponse.json()).then(jsonBookingResponse => {
                        this.setState({ accessReservationBookingDisabled: false });
                        this.props.onBookingRetrieved(jsonBookingResponse, jsonVerificationResponse.hash);
                    }).catch(error => {
                        this.setState({ accessReservationBookingDisabled: false });
                        this.setState({ 'showVerificationErrorMessage': true });
                        //this.setState({'verificationErrorMessage': error.toString()});
                        let mainPhoneNumber = this.props.franchiseData.mainPhoneNumber;
                        this.setState({
                            'verificationErrorMessage': 'We’re sorry.\n' +
                                'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with your vacation specialist for assistance.'
                        });
                    });
                }
            }).catch(error => {
                this.setState({ accessReservationBookingDisabled: false });
                this.setState({ 'showVerificationErrorMessage': true });
                let mainPhoneNumber = this.props.franchiseData.mainPhoneNumber;
                this.setState({
                    'verificationErrorMessage': 'We’re sorry.\n' +
                        'Your booking cannot be displayed at this time. Please call ' + mainPhoneNumber + ' to speak with your vacation specialist for assistance.'
                });
            });
        }
    }
    
       
    handleConfirmationEmailSubmitSwap = (event) => {

        if (this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N') {
            if (this.resendFormIsValidSwap()) {
                this.ajaxSpinnerShow();
                console.debug('Requesting swap to resend guest booking email confirmation');
                let url = '/wthrest/customer-self-service/sendConfirmationEmails.rs';
                let payload = {
                    "emailAddress": document.getElementById("resendEmail").value.trim(),
                    "lastName": document.getElementById("resendLastName").value.trim().toUpperCase(),
                    "sessionId" : this.getCookie("WDVID")
                };
                console.debug("Request: " + JSON.stringify(payload));
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }).then(emailConfirmationResponse => emailConfirmationResponse.json()).then(jsonEmailConfirmationResponse => {      	 
                    this.ajaxSpinnerHide();
                    var flag = true;
                    var index = 0;
                    console.debug("Response: " + JSON.stringify(jsonEmailConfirmationResponse));
                    const length = jsonEmailConfirmationResponse.length;
                    while(index < length && flag === true) {
                        if(jsonEmailConfirmationResponse[index].sendIvoiceStatus === 'Y') {
                           
    
                            flag = false;
                            this.resetInputVals();
                            this.setState({isBookingConfirmation: true})
                        }
                        index++;
                    }
                    if(flag === true) {
                        document.querySelector('.wth3-login-button-resendNoMatch-error').style.display = "block";
                        document.querySelector('.wth3-login-container').style.minHeight = '51.3125rem';
                        document.querySelector('.wth3-login__sub-header').style.marginBottom = '2rem';
                        document.querySelector('.wth3-login-button-resendNoMatch-error').focus();
                        this.props.CallTracker('BCSS Login','Resend Booking Confirmation Email','No Matches Found');
                    }
                }).catch(error => {
                    this.ajaxSpinnerHide();
                    let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                    let failureMessage = 'Your booking confirmation email cannot be sent at this time. Please call ' + mainPhoneNumber + ' to speak with your vacation specialist for assistance.';
                    document.querySelector('.wth3-login-button-resendFailure-error').style.display = "block";
                    document.querySelector('.wth3-login-button-resendFailure-error').innerHTML = failureMessage;
                    document.querySelector('.wth3-login-button-resendFailure-error').focus();
                    document.querySelector('.wth3-login-container').style.minHeight = '51.3125rem';
                    document.querySelector('.wth3-login__sub-header').style.marginBottom = '2rem';
                });  
    
            }
        } else {
            if (this.resendFormIsValidSwap()) {
                this.ajaxSpinnerShow();
                console.debug('Requesting swap to resend guest booking email confirmation');
                let url = '/wthrest/customer-self-service/sendConfirmationEmails.rs';
                let payload = {
                    "emailAddress": document.getElementById("resendEmail").value.trim(),
                    "lastName": document.getElementById("resendLastName").value.trim().toUpperCase(),
                    "sessionId" : this.getCookie("WDVID")
                };
                console.debug("Request: " + JSON.stringify(payload));
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }).then(emailConfirmationResponse => emailConfirmationResponse.json()).then(jsonEmailConfirmationResponse => {      	 
                    this.ajaxSpinnerHide();
                    var flag = true;
                    var index = 0;
                    console.debug("Response: " + JSON.stringify(jsonEmailConfirmationResponse));
                    const length = jsonEmailConfirmationResponse.length;
                    while(index < length && flag === true) {
                        if(jsonEmailConfirmationResponse[index].sendIvoiceStatus === 'Y') {
                            document.getElementById('successMessageBoxResend').style.display = "block";
                            this.props.CallTracker('BCSS Login','Resend Booking Confirmation Email','Success - Matches Found');
                            document.getElementById('resendLastName').value = ''
                            document.getElementById('resendEmail').value = ''
    
                            flag = false;
                        }
                        index++;
                    }
                    if(flag === true) {
                        document.getElementById('errorMessageBoxResend').style.display = "block";
                        this.props.CallTracker('BCSS Login','Resend Booking Confirmation Email','No Matches Found');
                    }
                }).catch(error => {
                    this.ajaxSpinnerHide();
                    let mainPhoneNumber = this.props.siteConfigData.cruisePhone;
                    let failureMessage = 'Your booking confirmation email cannot be sent at this time. Please call ' + mainPhoneNumber + ' to speak with your vacation specialist for assistance.';
                    document.getElementById('failureMessageBoxResend').style.display = "block";
                    document.getElementById('failureMessageBoxResendContent').innerHTML = failureMessage;
                });  
    
            }
            this.executeScroll();
        }
    }

}


export default withRouter(Verification)